import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { afterItems, beforeItems } from '../data/beforeAfter';
export function BeforeAfter() {
  return <section className="py-24 px-4 bg-ivory" data-id="element-19" data-mp="3ogav9qd0l15b">
      <div className="max-w-4xl mx-auto" data-id="element-20" data-mp="3ofhx3ds4fjys">
        <div className="text-center mb-12" data-id="element-21" data-mp="3sh37msh6nm5t">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy" data-id="element-22" data-mp="3sfs1wn46g4c2">
            Before &amp; After Swim Instructor Ready
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-23" data-mp="3jh6o159nhdhm">
          <motion.div initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-pearl border border-pearl-dark rounded-2xl p-8" data-id="element-24" data-mp="3jirgmpcemmcu">
            <h3 className="text-sm font-bold uppercase tracking-[0.2em] text-graphite mb-6" data-id="element-25" data-mp="2vtgbywrxo7tf">
              Before
            </h3>
            <ul className="space-y-4" data-id="element-26" data-mp="x40vkbc50o5z">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-27" data-mp="t2yrnh79znxo">
                  <MinusIcon size={18} className="text-graphite/50 shrink-0 mt-0.5" data-id="element-28" data-mp="t2p563lfvywq" />
                  <span className="text-graphite" data-id="element-29" data-mp="172801up8pdr3">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border-2 border-gold/50 rounded-2xl p-8" data-id="element-30" data-mp="ee2dd2emleom">
            <h3 className="text-sm font-bold uppercase tracking-[0.2em] text-gold-dark mb-6" data-id="element-31" data-mp="jdfb4i71c65z">
              After
            </h3>
            <ul className="space-y-4" data-id="element-32" data-mp="3rrxcy26duph5">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-33" data-mp="3mue096pc2krb">
                  <CheckIcon size={18} className="text-aqua-dark shrink-0 mt-0.5" data-id="element-34" data-mp="3ms1hirbr46d7" />
                  <span className="text-navy font-medium" data-id="element-35" data-mp="1qon2fur2jv0n">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}